import { useInjection } from 'inversify-react';
import { observer } from 'mobx-react-lite';
import { ReactElement, useEffect } from 'react';
import { IAlertBarBl } from './AlertBar.bl';
import { IAlertBarStore } from './AlertBar.store';
import { Alert } from './models/Alert';
import { AlertBar } from './ui/AlertBar';

export const AlertBarContainer = observer((): ReactElement => {
  const store = useInjection(IAlertBarStore.$);
  const bl = useInjection(IAlertBarBl.$);

  const initialize = async (): Promise<void> => {
    await bl.initializeAsync();
    bl.cleanup();
  };

  useEffect(() => {
    void initialize();
  }, []);

  const handleAlertOutdated = (alert: Alert): void => {
    bl.clearOutdatedAlert(alert);
  };

  return store.alerts.length > 0 ? (
    <AlertBar
      alerts={store.alerts}
      onAlertOutdated={handleAlertOutdated}
    />
  ) : (
    <></>
  );
});
